/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuTypeaheadContainer_itemSearch$ref = any;
export type SbSharedRefineMenuMultiSelectSearch_itemSearch$ref = any;
export type SbSharedRefineMenuMultiSelectSearch_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedRefineMenuTypeaheadContainer_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuMultiSelectSearch_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "localizedFilterName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canBeDismissed",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "linkReference",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayName",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '044a6fb9d93d8e2612fe67938e8a7898';
export default node;
